<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dWaV1s/tc-custom/9781605098814.jpg?1704717895140" alt="This image is the cover for the book How to Get Ideas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How to Get Ideas
      </h1>
      <p class="bookDescription body article font2">
        <b>This new expanded second edition shows you—no matter your age or skill, your job or training—how to come up with more ideas, faster and easier.</b><br/><br/> Jack Foster’s simple five-step technique for solving problems and getting ideas takes the mystery and anxiety out of the idea-generating process. It’s a proven process that works. You’ll learn to condition your mind to become “idea-prone,” utilize your sense of humor, develop your curiosity, visualize your goals, rethink your thinking, and overcome your fear of rejection.<br/><br/> This expanded edition of the inspiring and enlightening classic features new information on how to turn failures to your advantage and how to create a rich, idea-inducing environment. Dozens of new examples and real-life stories show that anyone can learn to get more and better ideas.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Foster, Larry Corby
      </h2>
      
      <p class="authorDescription body article">Jack Foster spent thirty-five years working in creative departments of major advertising agencies; the first ten as a writer, the last 25 as a creative director. He has helped create advertising for scores of companies including Carnation, Mazda, Sunkist, Mattel, Albertson's, Ore-Ida, Suzuki, Universal Studios, Rand McNally, and Smokey Bear. He is a recipient of the Los Angeles Creative Club’s  "Creative Person of the Year" award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?97415ec0